import React from 'react';
import BaseTextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import { InputProps } from '@material-ui/core';

import { TEXT_FIELD_COLOR, TEXT_FIELD_VARIANT } from '../../enum/formProps';

import './TextField.scss';

interface TextFieldProps {
  label: string;
  name: string;
  type: string;
  color?: TEXT_FIELD_COLOR;
  variant?: TEXT_FIELD_VARIANT;
  inputProps?: Partial<InputProps>;
  placeholder?: string;
}

const TextField: React.FC<TextFieldProps> = ({ label, inputProps, ...props }) => {
  const { t } = useTranslation();
  const [field, meta] = useField(props);
  const isError = !!(meta.error && meta.touched);

  return (
    <BaseTextField
      placeholder={props.placeholder}
      className="TextField-BaseTextField"
      error={isError}
      fullWidth
      helperText={isError ? t(meta.error ?? '') : ''}
      color={props.color}
      id={props.name}
      {...field}
      {...props}
    />
  );
};

export default TextField;
